if (!customElements.get('load-more-pagination')) {
  class LoadMorePagination extends HTMLElement {
      constructor() {
          super();
          const searchParams = new URLSearchParams(window.location.search);
          this.loadedAll = false;
          this.pagination = Number(this.dataset.pagination) || 12;

          if (searchParams.get('page')) {
              this.page = Number(searchParams.get('page'));
          } else {
              this.page = null;
          }
      }

      connectedCallback() {
          this.limit = Number(this.dataset.limit);
          this.path = this.dataset.path;
          this.sectionId = this.dataset.sectionId;
          this.wrapperSelector = this.dataset.wrapperSelector;

          if (this.page) {
              this.loadInitialPages();
          } else this.page = 1;

          this.addEventListener('click', (e) => {
              if (!e.target.closest('button')) return;
              this.loadNextPage();
          })
      }

      async loadInitialPages() {
          const pages = [...Array(this.page).keys()].reverse();
          for (const i of pages) {
              const pageIndexToLoad = pages[i] - (pages.length - (this.page + 1));
              if (this.loadedAll || pageIndexToLoad > this.page) break;

              const searchParams = new URLSearchParams(window.location.search);
              searchParams.set('page', pageIndexToLoad);
              const newUrl = `${this.path}?${searchParams.toString()}`;

              await this.fetchSection(`${newUrl}&section_id=${this.sectionId}`, pageIndexToLoad);
          }
      }

      async loadNextPage() {
          const searchParams = new URLSearchParams(window.location.search);
          this.page += 1
          searchParams.set('page', this.page);

          const newUrl = `${this.path}?${searchParams.toString()}`;

          this.fetchSection(`${newUrl}&section_id=${this.sectionId}`)
              .then(() => window.history.pushState({}, '', newUrl));
      }

      async fetchSection(url, pageIndex) {
          const wrapper = document.querySelector(`${this.wrapperSelector}`);
          let page = pageIndex ?? this.page;

          if (!wrapper) {
              console.error('load-more-pagination.js: missing wrapper to append paginated items to');
              return;
          }

          this.querySelector('[data-load-more]')?.classList.add('hidden');
          this.querySelector('[data-loading-spinner]')?.classList.remove('hidden');

          await fetch(url)
              .then((response) => response.text())
              .then((text) => {
                  const html = new DOMParser().parseFromString(text, "text/html");

                  [...html.querySelector(`${this.wrapperSelector}`).querySelectorAll('[data-product-tile]')]
                      .filter(tile => {
                          return !wrapper.querySelector(`[data-product-tile="${tile.dataset.productTile}"]`)
                      })
                      .forEach((tile, i) => {
                          tile.style.order = i + (this.pagination * page);
                          wrapper.appendChild(tile)
                      });
              })
              .then(() => {
                  if ([...document.querySelector(`${this.wrapperSelector}`).querySelectorAll('[data-product-tile]')].length >= this.limit) {
                      this.loadedAll = true;
                      this.closest('[data-loading-wrapper]')?.classList.add('hidden');
                      this.classList.add('hidden');
                  }
              })
              .finally(() => {
                  this.querySelector('[data-load-more]')?.classList.remove('hidden');
                  this.querySelector('[data-loading-spinner]')?.classList.add('hidden');
                  if (document.querySelector('[data-product-count]')) document.querySelector('[data-product-count]').innerHTML = document.querySelector(`${this.wrapperSelector}`).childElementCount;
                  if(document.querySelector('[data-product-count-progress]')) document.querySelector('[data-product-count-progress]')?.setAttribute('value', document.querySelector(`${this.wrapperSelector}`).childElementCount);
              })
      }
  }

  customElements.define('load-more-pagination', LoadMorePagination);
}

/*
  EXAMPLE USAGE
  *
  *
  *
  *
  <div data-append-pagination class="grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-x-1.5 gap-y-11 px-4 md:px-0">
    {% for product in collection.products %}
      <div data-product-tile>
          {% render 'product-tile', product: product %}
      </div>
    {% endfor %}
  </div>

  <div data-loading-wrapper class="flex flex-col gap-6 items-center justify-center pt-32 pb-12">
      <div class="w-52">
          {% render 'load-more-pagination',
              limit: collection.products_count,
              paginate: paginate,
              render_section: 'collection',
              wrapper_to_append: '[data-append-pagination]'
          %}
      </div>
      <label class="h6" for="progressBar-{{ section.id }}">
          Showing <span data-product-count>12</span> of {{ collection.products_count }} products
      </label>
      <progress id="progressBar-{{ section.id }}" class="h-0.5 w-56 mt-2" data-product-count-progress max="{{ collection.products_count }}" value="12"></progress>
  </div>
*/